import { Skeleton } from 'antd';
import { Column, Space } from 'farmhub-ui-core';

import { getDummyArray } from 'utils';

import { Wrapper } from './styles';

const MenuSkeleton = () => (
  <Wrapper>
    <Space height={18} />
    <Column styles={{ gap: 24 }}>
      {getDummyArray(5).map((item: any) => (
        <Column styles={{ gap: 12 }}>
          <Skeleton.Input style={{ width: 100, height: 12 }} />
          <Skeleton.Input style={{ width: 160, height: 16 }} />
          <Skeleton.Input style={{ width: 160, height: 16 }} />
          <Skeleton.Input style={{ width: 160, height: 16 }} />
        </Column>
      ))}
    </Column>
  </Wrapper>
);

export default MenuSkeleton;
